/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PlayerRatingRankingList = {
    type: 'array',
    contains: {
        type: 'SinglePlayerRatingRanking',
    },
} as const;
